module.exports = __webpack_public_path__ + "img/amusement-arcade.3fb20581.svg";